import {getRequest, putRequest, postRequest, deleteRequest} from './api-requests';
import apiConfig from '../../../api-config';

export const Orders = Object.freeze({
    list: (data = {}) => {
        let getString = `?pharmacy_id=${data.pharmacy_id}`;
        if(data.sortBy !== undefined){
            getString += `&sort_by=${data.sortBy}`;
        }
        if(data.orderStatus !== undefined){
            getString += `&order_status=${data.orderStatus}`;
        }
        if(data.offset !== undefined && data.limit !== undefined){
            getString += `&offset=${data.offset}&limit=${data.limit}`
        }

        return getRequest(`${apiConfig.base_url}/web/order${getString}`)
    },
    details: (id) => {
        return getRequest(`${apiConfig.base_url}/web/order/${id}`)
    },
    status: (id, status) => {
        return putRequest(`${apiConfig.base_url}/web/order/${id}`, {status: status});
    },
    getStatusMessage: (id, status) => {
        return postRequest(`${apiConfig.base_url}/web/order/${id}/message`, {status: status});
    },
    update: (id, data) => {
        return putRequest(`${apiConfig.base_url}/web/order/${id}`, data);
    },
    delete: (id) => {
        return deleteRequest(`${apiConfig.base_url}/web/order/${id}`);
    }
    // listReduced: () => getRequest(`${apiConfig.base_url}/web/company/list`),
    // pharmacyList: id => getRequest(`${apiConfig.base_url}/web/company/${id}/pharmacies`),
    // single: id => getRequest(`${apiConfig.base_url}/web/company/${id}`),
    // add: details => postRequest(`${apiConfig.base_url}/web/company`, details),
    // edit: (details, id) => putRequest(`${apiConfig.base_url}/web/company/${id}`, details),
    // statistics: (id) => {
    //     if(id != undefined){
    //         return getRequest(`${apiConfig.base_url}/web/company/${id}/statistic`);
    //     } else {
    //         return null;
    //     }
    // }
});


// WEBPACK FOOTER //
// ./src/customModules/Common/rest-api/api-orders.js